import { useTranslation } from 'providers/GILT.provider';

import PopupModalContainer from 'common/PopupModal';

/**
 * Shared blocked-action modal for the hardcoded staff-Stripe self-management
 * restriction (GS-5904 Phase 3). Used by every entry point that may try to
 * set up or manage another staff member's Stripe account, so the title, copy
 * and dismiss behaviour stay consistent.
 */
export const StaffStripeBlockedModal = ({ isOpen, message, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <PopupModalContainer tag="StaffStripeBlockedModal" popupTitle={t('stylistScreen.staffStripe.modalTitle')} popupMessage={message} buttonText={t('common.buttons.close')} buttonCallback={onClose} />
  );
};
